// /src/hooks/useSupabase.ts
import { supabase } from '@/lib/supabaseClient';
import { useAuth } from './useAuth';

export const useSupabase = () => {
  const { user } = useAuth();
  
  return {
    supabase,
    user
  };
};
